import * as Yup from 'yup'
import { OTP_INPUT_LENGTH } from 'src/components/auth/otp-input-form/OtpInputForm.interface'

export const ContractorPortalUpdatePhoneEnterCodeModalSchema = Yup.object().shape({
  code: Yup.string()
    .required('Verification code is required.')
    .length(OTP_INPUT_LENGTH, 'Verification code is required.'),
})
